import React from "react";
import { useHistory } from "react-router-dom";

function PaymentListItem({ card, onRemove }) {
  const link = useHistory();

  const linkToDetail = (params) => {
    link.push(`/payment-detail/${params}`);
  };

  return (
    <>
      {card && (
        <>
          <tr key={card.key}>
            <th colSpan="1" className="p-0">
              <span className="txt-dark-gray">
                {card.is_tax_bill === 1 ? "세금계산서" : "카드"}
              </span>
            </th>
            <th colSpan="1">
              <span
                className="underline-black underline-hover-blue cursor"
                onClick={() =>
                  linkToDetail(
                    `${card.is_tax_bill === 1 ? "tax_bill" : "card"}/${card.id}`
                  )
                }
              >
                {card.nickname}
              </span>
            </th>
            <th colSpan="1">
              <span className="txt-dark-gray">
                {card.company ? card.company : "-"}
              </span>
            </th>
            <th colSpan="3">
              <span className="txt-dark-gray">
                {card.protected_number ? card.protected_number : "-"}
              </span>
            </th>
            <th colSpan="1" className="p-0">
              <span className="txt-dark-gray">
                {card.is_tax_bill === 1 ? (
                  "불가"
                ) : (
                  <button
                    className="btn-white-sm pr-2 pl-2"
                    onClick={() => onRemove(card.id)}>
                    삭제
                  </button>
                )}
              </span>
            </th>
          </tr>
        </>
      )}
    </>
  );
}

export default PaymentListItem;
